export const config = {
  auth0: {
    clientId: process.env.REACT_APP_AUTH0_CLIENT_ID as string,
    domain: process.env.REACT_APP_AUTH0_DOMAIN as string,
  },
  api: {
    url: process.env.REACT_APP_API_URL as string,
    key: process.env.REACT_APP_API_KEY as string,
  },
}
